import { PaginationAndSortingValues } from '../components/moovyPagination'
import { getSortDirection } from '../components/moovySortControl/sortValues'
import { components } from './openapi'
import { ParkingEventsSortType } from './parkingEvents/dto'
import { WhitelistSortType } from './whitelist/dto'

export const API_ROOT_URL = '/v1'
export const API_ADMIN_ROOT_URL = '/admin/v1'
export const getBaseUrl = (admin: boolean) =>
  admin ? API_ADMIN_ROOT_URL : API_ROOT_URL

export type BasicPageSortQueryParams = {
  page?: number
  limit?: number
  direction?: components['schemas']['SortDirection']
}

export const DEFAULT_PAGE_SIZE = 20
export const DEFAULT_PAGE = 1

export type MofiSortType = ParkingEventsSortType | WhitelistSortType

export type SortDirectionDTO = components['schemas']['SortDirection']

export const getDefaultPaginationAndSortingValues = (
  sort: MofiSortType,
): PaginationAndSortingValues => ({
  page: DEFAULT_PAGE,
  limit: DEFAULT_PAGE_SIZE,
  direction: getSortDirection(sort),
  sort,
})

export type SearchParameters = Record<string, string | string[] | null>
export const onlyDefinedSearchParameters = (
  searchParameters?: SearchParameters,
) =>
  searchParameters
    ? Object.fromEntries(
        Object.entries(searchParameters).filter(([_, value]) => value),
      )
    : {}
